import { cva } from 'class-variance-authority';
import { Colors } from '@/lib/colorUtils';

export enum CircleLoaderSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export type CircleLoaderProps = {
  size?: CircleLoaderSize;
  color?: Colors;
  className?: string;
  /** Test hook placed on the root element. Defaults to `"circle-loader"` (PB-3325). */
  'data-cy'?: string;
};

const sizeMap = {
  [CircleLoaderSize.small]: 'tw:h-4 tw:w-4',
  [CircleLoaderSize.medium]: 'tw:h-5 tw:w-5',
  [CircleLoaderSize.large]: 'tw:h-6 tw:w-6',
} as const;

export const circleLoaderWrapperVariants = cva(
  'tw:inline-flex tw:items-center tw:justify-center tw:animate-spin tw:motion-reduce:animate-none',
  {
    variants: {
      size: sizeMap,
    },
    defaultVariants: {
      size: CircleLoaderSize.medium,
    },
  }
);
